import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  tab: {
    backgroundColor: theme.palette.primary.dark,
  },
  content: {
    maxWidth: theme.breakpoints.values['content'],
    margin: 'auto',
    textAlign: 'left',
  },
  noPad: {
    padding: '0 !important',
  },
}));

export default useStyles;
